import fb from '@/firebaseConfig';

/*

  STATE

 */

const state = {
  audioById: {},
  isLoaded: false,
};


/*

  GETTERS

 */

const getters = {
  currentPlaylist: (state, getters, rootState, rootGetters) => {
    const { audioById } = state;
    const { currentId, routeName } = rootState.ui;
    let cardIds = [currentId];
    if (routeName === 'Stack') {
      const stack = rootGetters['stacks/allStacks'][currentId] || {};
      cardIds = stack.cardIds || [];
    }
    const playlist = [];
    cardIds.forEach((id) => {
      const audio = audioById[id] || {};
      const mp3 = audio.m_mp3_url || '';
      const webm = audio.m_webm_url || '';
      if (mp3) {
        playlist.push([mp3, webm]);
      }
    });
    return playlist;
  },
};


/*

  ACTIONS

 */

const actions = {
  init({ commit, state, rootGetters }) {
    const { isLoaded } = state;
    const isPremiumUser = rootGetters['user/isPremiumUser'];
    if (isLoaded || !isPremiumUser) { return; }

    fb.audioCollection.get()
      .then((querySnapshot) => {
        const audioData = {};
        querySnapshot.forEach((doc) => {
          const { id } = doc;
          const data = doc.data();
          audioData[id] = data;
        });
        commit('setAudio', audioData);
      })
      .catch((error) => {
        console.log('Error getting audio', error);
      });
  },
};


/*

  MUTATIONS

 */

const mutations = {
  setAudio(state, data) {
    state.audioById = data;
    state.isLoaded = true;
  },
};


export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
